import { render, staticRenderFns } from "./AccountTBDetails.vue?vue&type=template&id=bfe69282&"
import script from "./AccountTBDetails.vue?vue&type=script&lang=js&"
export * from "./AccountTBDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfe69282')) {
      api.createRecord('bfe69282', component.options)
    } else {
      api.reload('bfe69282', component.options)
    }
    module.hot.accept("./AccountTBDetails.vue?vue&type=template&id=bfe69282&", function () {
      api.rerender('bfe69282', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/accountTB/AccountTBDetails.vue"
export default component.exports